import { Button } from "antd";
import classNames from "classnames";
import { random } from "lodash";
import { useRouter } from "next/router";
import { useMemo } from "react";

import Spinner from "@/components/Spinner";
import CardUserProfile from "@/components/v2/CardUserProfile/index";
import ErrorEmptyV2 from "@/components/v2/ErrorEmpty";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useGetConnections } from "@/hooks/useConnections";
import { PAGE_URL } from "@/utils/constants";

type RecommendedConnectionWidgetProps = {
  wrapperClassName?: string;
};

export default function RecommendedConnectionWidget({
  wrapperClassName = "",
}: RecommendedConnectionWidgetProps) {
  const router = useRouter();
  const {
    data: dataRecommendConnection,
    isLoading: isLoadingRecommendConnection,
  } = useGetConnections({
    showNonConnectionOnly: true,
    limit: 25,
    usePagination: true,
    isRecommendConnection: true,
  });
  const recommendedConnections = dataRecommendConnection?.data || [];
  const randomIndex = useMemo(() => {
    if (recommendedConnections && recommendedConnections.length > 0) {
      return random(0, recommendedConnections.length - 1);
    }
    return 0;
  }, [recommendedConnections]);
  const recommendedConnection = recommendedConnections?.[randomIndex];

  const { track } = useAnalytics();

  const onClickViewMore = () => {
    track(
      "View more recommended connections",
      "Click",
      `Page ${router.pathname}`
    );
    router.push({
      pathname: PAGE_URL.connections,
      query: { open: "recommended-connections" },
    });
  };

  return (
    <div
      className={`bg-card relative px-4 py-8 w-full flex flex-col h-full justify-center ${wrapperClassName}`}
    >
      {!isLoadingRecommendConnection && recommendedConnection && (
        <div className="top-4 right-6 flex justify-end absolute z-10">
          <Button type="text" style={{ padding: 0 }} onClick={onClickViewMore}>
            <span className="text-yellow">View More People</span>
          </Button>
        </div>
      )}
      <div
        className={classNames(
          "flex justify-center items-center text-white lg:h-[136px]",
          recommendedConnection?.length ? "mt-0" : "mt-7 xl:mt-0"
        )}
      >
        {isLoadingRecommendConnection ? (
          <Spinner size="md" />
        ) : recommendedConnection ? (
          <CardUserProfile
            avatarSize="sm"
            variant="vertical"
            containerClassName="!pt-0"
            item={recommendedConnections[randomIndex]?.user || {}}
            findCG
            hideMutual
            isNameCapitalized={false}
          />
        ) : (
          <ErrorEmptyV2 isFullWidth which="dashboard-recommendedConnection" />
        )}
      </div>
    </div>
  );
}
